import { useContext, useMemo } from "react";

import { Formik } from "formik";
import PropTypes from "prop-types";

import { Loader } from "components/elements";

import {
  adaptAttributesToForm,
  adaptAttributesToRequest,
  ManifestDataContext,
} from "../../ManifestData";
import { META_FIELDS } from "../constants";
import { VALIDATION_SCHEMA } from "../validation";

const SUCCESS_HANDLER_DEFAULT = () => {};

export function ManifestEditFormik({
  createUpdateManifest,
  onSuccess = SUCCESS_HANDLER_DEFAULT,
  children,
}) {
  const { app, manifest, loading } = useContext(ManifestDataContext);

  const initialValues = useMemo(
    () => ({
      ...adaptAttributesToForm(manifest?.attributes ?? {}),
      [META_FIELDS.appId]: app.id,
      [META_FIELDS.appMode]: app.mode,
      [META_FIELDS.targets]: manifest?.targets ?? {},
    }),
    [app, manifest]
  );

  const handleSubmit = async (values) => {
    const {
      [META_FIELDS.appId]: appId,
      [META_FIELDS.appMode]: _appMode,
      [META_FIELDS.targets]: targets,
      ...attributes
    } = values;
    const data = {
      provider_id: appId.trim(),
      attributes: await adaptAttributesToRequest(attributes),
      targets,
    };
    createUpdateManifest.mutate(data, {
      onSuccess: ({ results }) => onSuccess(results.id),
    });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validationSchema={VALIDATION_SCHEMA}
    >
      {children}
    </Formik>
  );
}

ManifestEditFormik.propTypes = {
  createUpdateManifest: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
  children: PropTypes.node.isRequired,
};
